<ngx-loading-bar
  [color]="'var(--color-primary-500)'"
  [height]="'2px'"
  [includeSpinner]="false"
></ngx-loading-bar>

<router-outlet></router-outlet>

@defer {
  <app-alert-notif-host></app-alert-notif-host>

  <!-- TODO: Move to a separate component app-notif-host -->
  <!-- default toast host element -->
  <p-toast #defaultToastRef>
    <ng-template let-message pTemplate="message">
      <span
        class="p-toast-icon pi"
        [ngClass]="{
          'pi-info-circle': message.severity === 'info',
          'pi-check': message.severity === 'success',
          'pi-exclamation-triangle': message.severity === 'warn',
          'pi-times-circle': message.severity === 'error',
        }"
      >
      </span>

      <div class="p-toast-message-text">
        @if (message.summary) {
          <div class="p-toast-summary">{{ message.summary }}</div>
        }

        @if (message.detail) {
          <div class="p-toast-detail">
            {{ message.detail }}
            @if (message.data?.link; as link) {
              @if (link.action) {
                <a
                  class="toast-link"
                  role="button"
                  tabindex="0"
                  (click)="runToastAction(link.action, defaultToastRef, message)"
                  (keydown.enter)="runToastAction(link.action, defaultToastRef, message)"
                  >{{ link.label }}</a
                >
              } @else {
                <a
                  class="toast-link"
                  [routerLink]="link.route"
                  [queryParams]="link.queryParams"
                  (click)="closeToast(defaultToastRef, message)"
                  >{{ link.label }}</a
                >
              }
            }
          </div>
        }
      </div>
    </ng-template>
  </p-toast>

  <!-- TODO: Move to app-notif-host component, rename key to `html-detail`-->
  <p-toast key="customDetail">
    <ng-template let-message pTemplate="custom">
      <div class="custom-detail flex gap-16 grow-1 align-items-center">
        <div class="icon-wrapper flex align-center justify-center">
          <i class="pi pi-check"></i>
        </div>
        <span class="text flex grow-1" [innerHTML]="message.detail"></span>
      </div>
    </ng-template>
  </p-toast>

  <app-chat-notif-host></app-chat-notif-host>

  <app-update-notif-host></app-update-notif-host>

  @if (!isNativePlatform) {
    <app-landscape-overlay></app-landscape-overlay>
  }
}
